import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustItems = [
    {
      icon: 'Shield',
      text: 'SSL Encrypted',
      color: 'text-success'
    },
    {
      icon: 'Lock',
      text: 'Secure Login',
      color: 'text-primary'
    },
    {
      icon: 'CheckCircle2',
      text: 'GDPR Compliant',
      color: 'text-accent'
    }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 lg:gap-8 py-4 md:py-5 lg:py-6">
      {trustItems?.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          <Icon name={item?.icon} size={16} className={item?.color} />
          <span className="text-xs md:text-sm text-muted-foreground font-medium">
            {item?.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;